export type ImageMetadata = [number, number, number, number];

export const getSubImageDataUrl = (
    spriteUrl: string,
    [x, y, width, height]: ImageMetadata,
): Promise<string> =>
    new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                return reject(new Error('Error creating canvas context'));
            }
            ctx.drawImage(img, x, y, width, height, 0, 0, width, height);
            try {
                resolve(canvas.toDataURL());
            } catch {
                reject(new Error('tainted canvas'));
            }
        };
        img.onerror = (err) => reject(err);
        img.src = spriteUrl;
    });
